module.exports = __webpack_public_path__ + "static/img/no_data.2f568076.png";